export default {
  active: 'Ativo',
  blocked: 'Bloqueado',
  inactive: 'Inativo',
  options: [
    { value: 'active', text: 'Ativo' },
    { value: 'blocked', text: 'Bloqueado' },
    { value: 'inactive', text: 'Inativo' }
  ]
};
